<template>
  <div class="landing-video landing-section">
    <div class="container">
        <h2 data-aos="fade-up">{{ $t('landing.video.title', 'landing') }}</h2>
        <div class="wrap-video">
            <video poster="@/assets/img/video_poster.jpg" id="landing-video" @click="videoClick" 
                data-aos="fade" data-aos-delay="300" data-aos-duration="500">
                <source :src="$t('landing.video.url', 'landing')" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <img id="landing-video-play-icon" src="@/assets/img/vid_play.png" @click="videoClick">
        </div>
        
        <p data-aos="fade" data-aos-delay="300" data-aos-duration="500" data-aos-anchor=".wrap-video">{{ $t('landing.video.description', 'landing') }}</p>
    </div>
  </div>
</template>

<script>

export default {
    name      : 'Video',
    components: {
    },
    data () {
        return {

        }
    },
    watch: {
    },
    mounted () {
    },
    computed: {
    },
    methods: {
        videoClick() {
            const video = document.getElementById('landing-video');
            if (!video.hasAttribute("controls")) {
                document.getElementById('landing-video-play-icon').remove();
                video.play();
                setTimeout(() => video.setAttribute("controls","controls"), 200);
            }
        }
    },
}
</script>

<style scoped lang="scss">
    @import '@/assets/scss/_variables.scss';

    .landing-video {
        background-color: #fff;
        overflow: auto;

        h2 {
            margin-top: 86px;
            text-align: center;

            font-family: 'Robusta TL Pro';
            font-style: normal;
            font-weight: 900;
            font-size: 40px;
            line-height: 78px;

            /* identical to box height, or 194% */
            text-align: center;
            text-transform: uppercase;

            color: $blue;
        }

        .wrap-video {
            widows: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 67px;

            img {
                position: absolute;
                cursor: pointer;
            }
        }

        video {
            width: 100%;
            cursor: pointer;
        }

        p {
            font-family: 'Rubik';
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 25px;

            /* or 139% */
            text-align: center;

            /* dark blue */
            color: $blue;
        }
    }

    @media only screen and (max-width: $break-sm){
        .landing-video { 
            padding-bottom: 178px;

            h2 {
                font-size: 30px;
                line-height: 30px;
                margin-bottom: 50px;
            }

            .wrap-video {
                margin-bottom: 65px;

                img {
                    width: 70px;
                }
            }

            p {
                font-size: 16px;
                line-height: 20px;
            }
        }
    }
</style>